module.exports = __webpack_public_path__ + "static/media/ts6cr168.31acf8ee.png";